import { setSectionHidden } from '../budget/repo'
import { navigate } from '../lib/router'
import { useStore } from '../store'
import { Card, Switch, TopBar } from '../ui/parts'
import { SECTIONS, isHidden } from './sections'

/**
 * Which sections exist is a preference, not a build-time decision. Turning one off removes
 * it from the bottom bar, the dashboard and the Other drawer at once — they all read the
 * same list, so nothing can be half-hidden.
 */
export function SettingsSection() {
  const { snapshot, mutate, account, logout } = useStore()
  if (!snapshot) return null

  const hidden = snapshot.app.hiddenSections

  return (
    <div className="screen">
      <TopBar title="Settings" onBack={() => navigate('/other')} />

      <div className="stack">
        <Card>
          <div className="card-title">Sections</div>
          <div className="muted" style={{ fontSize: 13, margin: '2px 0 10px' }}>
            Hidden sections disappear from the dashboard and the navigation. Nothing is
            deleted — switch one back on and its data is where you left it. This screen
            stays here whatever you turn off, so there is always a way back.
          </div>

          {SECTIONS.map((section) => (
            <div className="row between setting-row" key={section.id}>
              <div className="grow">
                <div style={{ fontWeight: 550 }}>{section.label}</div>
                <div className="muted" style={{ fontSize: 12 }}>
                  {section.inNav ? 'In the bottom bar' : 'Under Other'}
                </div>
              </div>
              <Switch
                label={`Show ${section.label}`}
                checked={!isHidden(hidden, section.id)}
                onChange={(on) => void mutate((s) => setSectionHidden(s, section.id, !on))}
              />
            </div>
          ))}
        </Card>

        <Card>
          <div className="card-title">Account</div>
          <div className="muted" style={{ fontSize: 13, margin: '2px 0 12px' }}>
            Signed in as {account?.name ?? 'this account'}. Signing out clears the cached
            copy on this device; your data stays on the server.
          </div>
          <button type="button" className="btn outline" onClick={() => void logout()}>
            Sign out
          </button>
        </Card>
      </div>
    </div>
  )
}
